import { render, staticRenderFns } from "./PopupAddMeetingInstance.vue?vue&type=template&id=af485b4c&scoped=true&"
import script from "./PopupAddMeetingInstance.vue?vue&type=script&lang=js&"
export * from "./PopupAddMeetingInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af485b4c",
  null
  
)

export default component.exports